import React from 'react';
import Input from "../../Input/Input";

var FeedbackModalRating = function FeedbackModalRating(_ref) {
  var highRatingText = _ref.highRatingText,
      lowRatingText = _ref.lowRatingText,
      ratingValidationError = _ref.ratingValidationError,
      setRating = _ref.setRating;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "feedback-modal-rating"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex mb-2 mx-3 justify-content-between"
  }, /*#__PURE__*/React.createElement("span", {
    className: "js-low-rating-text font-italic"
  }, lowRatingText), /*#__PURE__*/React.createElement("span", {
    className: "js-high-rating-text font-italic"
  }, highRatingText)), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-around mb-2"
  }, [1, 2, 3, 4, 5].map(function (rating) {
    return /*#__PURE__*/React.createElement("div", {
      "data-testid": "rating-".concat(rating),
      key: "rating-".concat(rating)
    }, /*#__PURE__*/React.createElement("div", null, rating), /*#__PURE__*/React.createElement(Input, {
      className: "ms-auto mt-2",
      type: "radio",
      name: "rating",
      "data-value": rating,
      onClick: function onClick() {
        return setRating(rating);
      }
    }));
  }))), /*#__PURE__*/React.createElement("span", {
    className: "text-danger"
  }, ratingValidationError));
};

FeedbackModalRating.displayName = "FeedbackModalRating";
export default FeedbackModalRating;